import { useItemAmount } from "../../../fetch/fetch.item.ts";

const ItemAmount = ({ userId }: { userId: string }) => {
  const { amountItems, isLoading, isError } = useItemAmount(userId, 0);
  if (isLoading) return "x";
  if (isError) return isError;
  return String(amountItems);
};
export default ItemAmount;
